import { withStyles } from '@material-ui/core';
import styles from '../SnackBar/styles';
import SurveyQuestionsComponent from './SurveyQuestionsComponent';

export default withStyles(styles)(SurveyQuestionsComponent);
